import { uniformGridSpec } from '@/utils/gridSpec';

import { LayoutTemplate, TemplateGroup } from '../layoutTemplates.types.ts';
import { PageNames } from '../pageNames.ts';

/** Templates suited to ultra-wide (32:9) screens. */
export const ultrawideTemplates: LayoutTemplate[] = [
  {
    id: 'grid-2x1',
    name: 'grid-2x1',
    group: TemplateGroup.Ultrawide,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(2, 1),
  },
  {
    id: 'grid-4x2',
    name: 'grid-4x2',
    group: TemplateGroup.Ultrawide,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(4, 2),
  },
  {
    id: 'grid-8x4',
    name: 'grid-8x4',
    group: TemplateGroup.Ultrawide,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(8, 4),
  },
];
